import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Impressum = function () {
  return (
    <footer>
      <Link to="/priceList">Preise</Link> | <Link to="/impressum" >Impressum</Link> | <Link to="/agb" >AGB</Link> | <Link to="/about">Über Pet Pate</Link>
    </footer>
  );
};

export default (Impressum);



// WEBPACK FOOTER //
// ./src/pages/Footer/index.js